export default class Asset {
  constructor(
    idInDB,
    externalId,
    name,
    isLowValue,
    underlyingAssetTypeId,
    businessUnitId,
  ) {
    this.idInDB = idInDB; // can be null
    this.externalId = externalId; // can be null
    this.name = name;
    this.isLowValue = isLowValue;
    this.underlyingAssetTypeId = underlyingAssetTypeId;
    this.businessUnitId = businessUnitId;
  }

  static createFromData(data) {
    if (data == null) throw new Error("Cannot create Asset from data if data is null.");

    return new Asset(
      data.idInDB,
      data.externalId,
      data.name,
      data.isLowValue,
      data.underlyingAssetTypeId,
      data.businessUnitId);
  }

  static createNew() {
    return new Asset(
      null,
      null,
      null,
      false,
      null,
      null,
    );
  }
}
